<template>
  <div class="p-6 space-y-12">
    <header v-if="title" :class="headerClasses">
      <page-title :title :description>
        <template #action>
          <slot name="action" />
        </template>
      </page-title>
    </header>
    <main :class="mainClasses">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import PageTitle from "@/components/ui/PageTitle.vue";

defineProps<{
  title?: string;
  description?: string;
  headerClasses?: string;
  mainClasses?: string;
}>();
</script>
